<template>
  <div>
    <span
      v-if="hasSupport"
      class="ffk-cursor-pointer"
      @click="$emit('on-click-support')"
      v-b-tooltip
      :title="$t('appSwitcher.support')"
    >
      <font-awesome-icon :icon="['fas', 'headset']" class="text-white" />
    </span>
    <span
      v-if="hasMultipleApps"
      :class="[hasSupport ? 'ml-3' : 'ml-1', 'mr-1', 'ffk-cursor-pointer']"
      id="apps-list-open-icon"
      v-b-tooltip
      :title="$t('appSwitcher.title')"
    >
      <font-awesome-icon :icon="['fal', 'grip-vertical']" class="text-white" />
    </span>
  </div>
</template>

<script>
export default {
  name: 'AppSwitcherIcon',
  props: {
    hasMultipleApps: {
      type: Boolean,
      default: false,
    },
    hasSupport: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
